
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/insights",
      function () {
        return require("private-next-pages/insights/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/insights"])
      });
    }
  